<template>
  <div class="page">
    <el-card shadow="never">
      <div slot="header" class="card-header">
        <span>常见问题</span>
        <el-button type="primary" size="small" @click="openDialog(null)">新增</el-button>
      </div>
      <el-table v-loading="loading" :data="list" border stripe>
        <el-table-column prop="id" label="ID" width="60" />
        <el-table-column label="场景" width="100">
          <template slot-scope="{ row }">{{ sceneLabel(row.scene) }}</template>
        </el-table-column>
        <el-table-column prop="question" label="问题" min-width="200" />
        <el-table-column prop="sortOrder" label="排序" width="70" />
        <el-table-column label="状态" width="80">
          <template slot-scope="{ row }">{{ labelOf(COMMON_STATUS, row.status) }}</template>
        </el-table-column>
        <el-table-column label="操作" width="140" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="openDialog(row)">编辑</el-button>
            <el-button type="text" size="small" class="danger" @click="remove(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog :title="form.id ? '编辑常见问题' : '新增常见问题'" :visible.sync="visible" width="640px">
      <el-form ref="form" :model="form" :rules="rules" label-width="88px">
        <el-form-item label="场景" prop="scene">
          <el-select v-model="form.scene" style="width: 100%">
            <el-option v-for="opt in sceneOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="问题" prop="question">
          <el-input v-model="form.question" />
        </el-form-item>
        <el-form-item label="回答" prop="answer">
          <el-input v-model="form.answer" type="textarea" :rows="8" />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.sortOrder" :min="0" style="width: 100%" />
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="form.status" style="width: 100%">
            <el-option v-for="opt in statusOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" :loading="submitting" @click="submit">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getFaqs, saveFaq, deleteFaq } from '@/api/admin'
import { COMMON_STATUS, labelOf, optionsOf } from '@/utils/adminConstants'

export default {
  name: 'AdminFaq',
  data() {
    return {
      COMMON_STATUS,
      loading: false,
      list: [],
      visible: false,
      submitting: false,
      sceneOptions: [
        { value: 'all', label: '全部页面' },
        { value: 'membership', label: '会员中心' },
        { value: 'points', label: '积分超市' }
      ],
      form: { id: null, scene: 'all', question: '', answer: '', sortOrder: 0, status: 1 },
      rules: {
        scene: [{ required: true, message: '请选择场景', trigger: 'change' }],
        question: [{ required: true, message: '请输入问题', trigger: 'blur' }],
        answer: [{ required: true, message: '请输入回答', trigger: 'blur' }]
      }
    }
  },
  computed: {
    statusOptions() {
      return optionsOf(COMMON_STATUS)
    }
  },
  created() {
    this.loadList()
  },
  methods: {
    labelOf,
    sceneLabel(scene) {
      const map = { all: '全部', membership: '会员中心', points: '积分超市' }
      return map[String(scene || '').toLowerCase()] || scene || '-'
    },
    async loadList() {
      this.loading = true
      try {
        this.list = await getFaqs() || []
      } catch (e) {
      } finally {
        this.loading = false
      }
    },
    openDialog(row) {
      this.form = row
        ? { ...row }
        : { id: null, scene: 'all', question: '', answer: '', sortOrder: 0, status: 1 }
      this.visible = true
    },
    async remove(row) {
      if (!row || !row.id) return
      try {
        await this.$confirm('确定删除该常见问题？', '提示', { type: 'warning' })
        await deleteFaq(row.id)
        this.$message.success('已删除')
        this.loadList()
      } catch (e) {
      }
    },
    submit() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        this.submitting = true
        try {
          await saveFaq(this.form)
          this.$message.success('保存成功')
          this.visible = false
          this.loadList()
        } catch (e) {
          this.$message.error((e && e.message) || '保存失败')
        } finally {
          this.submitting = false
        }
      })
    }
  }
}
</script>

<style scoped>
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.danger {
  color: #f56c6c;
}
</style>
